// extracted by mini-css-extract-plugin
module.exports = {"cell":"ListTable-Cell--cell--1uINj","variantCondensed":"ListTable-Cell--variantCondensed--1ZQw5"};